import React from "react";
import { Box, Typography, Checkbox, Tooltip } from "@mui/material";
import docDelete from "../../../assets/workingDocIcons/docDelete.svg";
import { DELETE_ONEDRIVE_DOC, DELETE_ONEDRIVE_DOC_TOOLTIP } from "../../../redux/constants/labelText";
import { useTheme } from "../../../theme/OAS365Theme";

/**
 * Delete OneDrive original checkbox with label and icon for check-in new revision.
 */
function DeleteOneDriveCheckbox({ checked, onChange }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        mt: "10px",
        paddingLeft: "5px",
        paddingRight: "16px",
        height: "43px",
        backgroundColor: "#F0EEE2",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "-webkit-fill-available",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Checkbox
          checked={checked}
          onChange={onChange}
          sx={{
            color: "#AE9B2E",
            "&.Mui-checked": { color: "#AE9B2E" },
          }}
        />
        <Tooltip title={DELETE_ONEDRIVE_DOC_TOOLTIP} placement="top" arrow>
          <Typography
            sx={{
              color: "#AE9B2E",
              fontWeight: "bold",
              fontFamily: theme.fonts.regular,
              fontSize: `${theme.fontSizes?.normal ?? 12}px`,
              cursor: "default",
            }}
          >
            {DELETE_ONEDRIVE_DOC}
          </Typography>
        </Tooltip>
      </Box>
      <Box component="img" src={docDelete} alt="icon" sx={{ width: 30, height: 30 }} />
    </Box>
  );
}

export default DeleteOneDriveCheckbox;
